export default __webpack_public_path__ + "static/media/spheroids.0c1c91d6.png";